import { useState } from 'react';
import Cookies from 'js-cookie';

import { getPublicClientApplicationInstance } from 'utils/functions/authentication';
import authentication from 'configs/authentication';
import LoginComponent from 'modules/accountManagement/components/LoginComponent';

const { authConfig } = authentication;
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const LoginContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [authenticationError, setAuthenticationError] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleSubmitBtnClick = async () => {
    setIsAuthenticating(true);

    try {
      const result = await getPublicClientApplicationInstance().loginPopup({
        scopes: authConfig.scopes,
        prompt: 'select_account',
      });
      const { name, email } = result.idTokenClaims;
      const dateAfterOneWeek = new Date(new Date().setHours(168));
      Cookies.set('nameAuthCookie', name, {
        expires: dateAfterOneWeek,
      });
      Cookies.set('emailAuthCookie', email, {
        expires: dateAfterOneWeek,
      });

      const returnURL = sessionStorage.getItem('docNetPortalReturnURL') || '/';
      console.log(returnURL);
      window.location.href = returnURL;
    } catch (err) {
      setIsAuthenticating(false);
      setAuthenticationError(err.errorMessage);
    }
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <LoginComponent
      isAuthenticating={isAuthenticating}
      authenticationError={authenticationError}
      handleSubmitBtnClick={handleSubmitBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

LoginContainer.propTypes = {};

LoginContainer.defaultProps = {};

export default LoginContainer;
